import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Collapse,
  Grid,
  IconButton,
  Paper,
  styled,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import React, { useMemo, useEffect } from "react";

import { useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ConnectedCallTable from "./ConnectedCallTable";
import MissedCallTable from "./MissedCallTable";

// FancyCard (Styled Paper)
const FancyCard = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  backgroundColor: theme.palette.primary.light,
  borderRadius: theme.shape.borderRadius,
  boxShadow: theme.shadows[3],
  marginBottom: theme.spacing(2),
  textAlign: "center",
}));

// InfoBox (Styled Box for task info)
const InfoBox = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(1),
  padding: theme.spacing(1),
  backgroundColor: theme.palette.secondary.main,
  borderRadius: theme.shape.borderRadius,
  boxShadow: theme.shadows[1],
  display: "inline-block",
  width: "100%",
  textAlign: "center",
}));

const ExpandIcon = styled(IconButton)(({ theme, expand }) => ({
  transform: expand ? "rotate(180deg)" : "rotate(0deg)",
  transition: theme.transitions.create("transform", {
    duration: theme.transitions.duration.shortest,
  }),
}));

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
};

const DataDisplayCard = ({ callStatistics, metricData, filters, setFilters, setMetricData,setLoading }) => {
  const [isExpanded, setIsExpanded] = useState(true); // Single card starts expanded
// const [loading, setLoading] = useState(false);

  const handleExpandClick = () => {
    setIsExpanded((prev) => !prev); // Toggle the expanded state
  };

  const [tabValues, setTabValues] = useState({}); // Object to track each card's tab state

  const handleTabChange = (index, newValue) => {
    setTabValues((prevValues) => ({
      ...prevValues,
      [index]: newValue, // Update the specific card's tab state
    }));
  };

  const defaultMetricData = {
    total_calls: 0,
    connected_calls: 0,
    missed_calls: 0,
    total_talk_time: 0,
    connection_rate: 0,
  };

  const metrics = metricData || defaultMetricData;
  // Check if `callStatistics` has valid data
  const hasData = Array.isArray(callStatistics) && [callStatistics].length > 0;


  return (
    <>
      {/* Data Display */}
      <Grid container spacing={2} sx={{ padding: 2 }}>
        {hasData ? (
          callStatistics.map((item, index) => (
            <Grid item xs={12} key={item.EmployeeName || index}>
              <Card
                sx={{
                  boxShadow: 3,
                  borderRadius: 2,
                  overflow: "hidden",
                }}
              >
                <CardHeader
                  title={
                    <div>
                      <Grid container spacing={2} sx={{ marginTop: "-4px" }}>
                        <Grid item xs={12} sm={4}>
                          <Typography
                            variant="subtitle1"
                            sx={{ fontWeight: 600 }}
                          >
                            {item.EmployeeName || "Unknown Agent"}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={8}>
                          <Grid container spacing={2} justifyContent="center">
                            <Grid
                              item
                              xs={6}
                              sm={3}
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <InfoBox
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                  padding: "6px 12px", // Adjust padding for better spacing
                                  backgroundColor: "#f5f5f5",
                                  // border: '2px #9c27b0 solid',
                                  borderRadius: "8px",
                                  width: "100%",
                                }}
                              >
                                <Typography
                                  variant="caption"
                                  color="black"
                                  sx={{ fontWeight: "bold" }}
                                >
                                  Total
                                </Typography>
                                <Typography
                                  variant="body2"
                                  color="#2196f3"
                                  sx={{ fontWeight: "bold" }}
                                >
                                  {metrics.totalCalls}
                                </Typography>
                              </InfoBox>
                            </Grid>
                            <Grid
                              item
                              xs={6}
                              sm={3}
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <InfoBox
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                  padding: "6px 12px", // Adjust padding for better spacing
                                  backgroundColor: "#f5f5f5",
                                  // border: '2px #FF8C00 solid',
                                  borderRadius: "8px",
                                  width: "100%",
                                }}
                              >
                                <Typography
                                  variant="caption"
                                  color="black"
                                  sx={{ fontWeight: "bold" }}
                                >
                                  Connected
                                </Typography>
                                <Typography
                                  variant="body2"
                                  color="#FF8C00"
                                  sx={{ fontWeight: "bold" }}
                                >
                                  {metrics.connectedCalls}
                                </Typography>
                              </InfoBox>
                            </Grid>
                            <Grid
                              item
                              xs={6}
                              sm={3}
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <InfoBox
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                  padding: "6px 12px", // Adjust padding for better spacing
                                  backgroundColor: "#f5f5f5",
                                  // border: '2px solid #4caf50' ,
                                  borderRadius: "8px",
                                  width: "100%",
                                }}
                              >
                                <Typography
                                  variant="caption"
                                  color="black"
                                  sx={{ fontWeight: "bold" }}
                                >
                                  Connected Rate
                                </Typography>
                                <Typography
                                  variant="body2"
                                  color="#4caf50"
                                  sx={{ fontWeight: "bold" }}
                                >
                                  {metrics.connectionRate}
                                </Typography>
                              </InfoBox>
                            </Grid>
                            <Grid
                              item
                              xs={6}
                              sm={3}
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <InfoBox
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                  padding: "6px 12px", // Adjust padding for better spacing
                                  backgroundColor: "#f5f5f5",
                                  // border: '2px solid #e53935',
                                  borderRadius: "8px",
                                  width: "100%",
                                }}
                              >
                                <Typography
                                  variant="caption"
                                  color="black"
                                  sx={{ fontWeight: "bold" }}
                                >
                                  Missed
                                </Typography>
                                <Typography
                                  variant="body2"
                                  color="#e53935"
                                  sx={{ fontWeight: "bold" }}
                                >
                                  {metrics.missedCalls}
                                </Typography>
                              </InfoBox>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </div>
                  }
                  action={
                    <ExpandIcon expand={isExpanded} onClick={handleExpandClick}>
                      <ExpandMoreIcon />
                    </ExpandIcon>
                  }
                  sx={{
                    backgroundColor: "#f5f5f5",
                    borderBottom: "1px solid #e0e0e0",
                    padding: "0px 12px", // Reduced padding to make header smaller
                    height: "auto", // Ensures the header height adjusts dynamically based on content
                    "& .MuiCardHeader-action": {
                      marginTop: "5px",
                    },
                  }}
                />
                <Collapse in={isExpanded} timeout="auto" unmountOnExit>
                  <CardContent sx={{ paddingTop: 0 }}>
                    <Tabs
                      value={tabValues[index] || 0} // Default to 0 if not set
                      onChange={(event, newValue) =>
                        handleTabChange(index, newValue)
                      }
                      aria-label="wrapped label tabs example"
                    >
                      <Tab
                        label={`Connected (${metrics.connectedCalls || 0})`}
                        id={`tab-${index}-0`}
                        iconPosition="start"
                        aria-controls={`tabpanel-${index}-0`}
                      />
                      <Tab
                        label={`Missed (${metrics.missedCalls || 0})`}
                        id={`tab-${index}-1`}
                        iconPosition="start"
                        aria-controls={`tabpanel-${index}-1`}
                      />
                    </Tabs>

                    <TabPanel value={tabValues[index] || 0} index={0}>
                      <ConnectedCallTable callStatistics={callStatistics} filters={filters} setFilters={setFilters} setMetricData={setMetricData} setLoading={setLoading} />
                    </TabPanel>
                    <TabPanel value={tabValues[index] || 0} index={1}>
                      <MissedCallTable callStatistics={callStatistics} filters={filters} setFilters={setFilters} setMetricData={setMetricData} setLoading={setLoading} />
                    </TabPanel>
                  </CardContent>
                </Collapse>
              </Card>
            </Grid>
          ))
        ) : (
          <Typography>No data available</Typography>
        )}
      </Grid>
    </>
  );
};

export default DataDisplayCard;
